import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import bar1Animation from '../assets/bar1Animation.svg';
import bar2Animation from '../assets/bar2Animation.svg';

const useStyles = makeStyles((theme) => ({
  infoGraphCont: {
    marginTop: '3.125rem',
    width: '51%',
    maxWidth: '600px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      textAlign: 'left'
    }
  },
  infoGraphTit: {
    ...theme.extraFonts.insertTitle
  },
  barNLabel: {
    marginTop: '1.25rem'
  },
  graphicImg: {
    marginLeft: '1rem',
    height: '40px',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0
    }
  },
  graphic1: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '278px'
    }
  }
}));

const WhyDoesStat1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: 'true' });

  const renderer = (
    <Grid
      container
      justifyContent={matchesSM ? 'flex-start' : 'center'}
      className={classes.graphic1}
    >
      <Typography className={classes.infoGraphTit}>
        Cervical Cancer Rates
        <br /> (Per 100,000 women)
      </Typography>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
        style={{ width: '80%' }}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          direction={matchesSM ? 'column' : 'row'}
          className={classes.barNLabel}
        >
          <Typography variant="body2" style={{ width: '110px' }}>
            Hispanic Women
          </Typography>
          <object
            type="image/svg+xml"
            data={bar1Animation}
            aria-label="graphic bar"
            className={classes.graphicImg}
          ></object>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          direction={matchesSM ? 'column' : 'row'}
          className={classes.barNLabel}
        >
          <Typography variant="body2" style={{ width: '110px' }}>
            White Women
          </Typography>
          <object
            type="image/svg+xml"
            data={bar2Animation}
            aria-label="graphic bar"
            className={classes.graphicImg}
          ></object>
        </Grid>
      </Grid>
      <Typography variant="body2" className={classes.infoGraphText}>
        Hispanic women have the highest rate of cervical cancer amongst women, and the
        advanced-stage mortality rate for every 100,000 Hispanic women is 9.5 compared to 7.5 white
        women.<sup>9</sup>
      </Typography>
    </Grid>
  );

  return (
    <>
      <Grid
        component={motion.div}
        ref={ref}
        container
        justifyContent="center"
        alignItems="center"
        className={classes.infoGraphCont}
      >
        {inView ? renderer : null}
      </Grid>
    </>
  );
};

export default WhyDoesStat1;
